import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'reactstrap';

import { LRS_ACTIONS } from '@techchange/components';
import { messages } from '../../i18n';

import { COMPLETION_TRACKER_STATUS } from '../../constants';

const propTypes = {

	/**
	 * The resource.
	 */
	resource: PropTypes.shape({

		id: PropTypes.string.isRequired,

		type: PropTypes.string.isRequired,

		title: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The rule for the resource.
	 */
	rule: PropTypes.shape({

		condition: PropTypes.shape({

			subconditions: PropTypes.arrayOf(PropTypes.shape({

				id: PropTypes.string.isRequired,

				active: PropTypes.bool.isRequired,

				action: PropTypes.string.isRequired,

				object_type: PropTypes.string.isRequired,

				object_id: PropTypes.string,

			})),

		}),

		tracker: PropTypes.shape({

			/**
			 * The completion tracker status.
			 */
			status: PropTypes.string.isRequired,

		}),

	}),

	/**
	 * Callback function to handle clicking the button.
	 */
	onClick: PropTypes.func.isRequired,

};

const SelfCompleteButton = (props) => {

	const { resource, rule, onClick } = props;

	const intl = useIntl();

	// Check if the rule for the resource supports self completion
	if (rule && rule.condition && rule.condition.subconditions) {

		// Check if there is a matching subcondition
		const match = rule.condition.subconditions.find((sub) =>
			sub.active &&
			sub.action === LRS_ACTIONS.MARKED_COMPLETE &&
			sub.object_type === resource.type &&
			sub.object_id === resource.id
		);

		if (match) {

			// Check if the user has already marked the resource as completed
			const isComplete =
				match.tracker &&
				match.tracker.status === COMPLETION_TRACKER_STATUS.COMPLETE;

			return (
				<Button
					className="tc-mark-complete-button"
					color="primary"
					aria-label={isComplete
						? intl.formatMessage(messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE_ARIA_LABEL, {
							title: resource.title
						})
						: intl.formatMessage(messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE_ARIA_LABEL, {
							title: resource.title
						})
					}
					title={isComplete
						? intl.formatMessage(messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE_ARIA_LABEL, {
							title: resource.title
						})
						: intl.formatMessage(messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE_ARIA_LABEL, {
							title: resource.title
						})
					}
					disabled={isComplete}
					onClick={onClick}>
					{isComplete
						? <FormattedMessage {...messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_COMPLETE} />
						: <FormattedMessage {...messages.TC_COMPONENTS_SELF_COMPLETE_BUTTON_MARK_COMPLETE} />
					}
				</Button>
			);

		}

	}

	return null;

};

SelfCompleteButton.propTypes = propTypes;

export default SelfCompleteButton;
